module.exports = __webpack_public_path__ + "img/8.8f1647a8.jpg";